// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"94f0a63decf406d4aea9","691":"9f343130f341aed5ccda","731":"029a708a67374dea8082","843":"98b85475a4e37eae63b5"}[chunkId] + ".js";
};